import React, { createContext, useReducer, useRef } from 'react';

const DragAndDropStore = createContext<any>(null);
const { Provider } = DragAndDropStore;

export enum DragAndDropContextActions {
  SET_DRAG_ITEMS,
  SET_ACTIVE_BREADCRUMB
}
// @ts-ignore
const DragAndDropProvider = ({ children }) => {
  const initialState = {
    dragItem: useRef(),
    dragNode: useRef(),
    highlightBreadCrumb: { id: null }
  };

  const [state, dispatch] = useReducer<any>((state: any, action: any) => {
    switch (action.type) {
      case DragAndDropContextActions.SET_DRAG_ITEMS:
        return {
          ...state,
          ...action.payload
        };
      case DragAndDropContextActions.SET_ACTIVE_BREADCRUMB:
        return {
          ...state,
          highlightBreadCrumb: action.payload
        };
      default:
        return state;
    }
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { DragAndDropStore, DragAndDropProvider };
